export class Node {
  public static SHAPE: string = 'shape';
  public static COLOR: string = 'color';
  public static MUTATION: string = 'mutation';
  public static SPECIES: string = 'species';
  public static INTERACTOR_NAME: string = 'interactor_name';
  public static INTERACTOR_TYPE: string = 'interactor_type';
  public static INTERACTOR_AC: string = 'id';
  public static INTERACTOR_ID: string = 'preferred_id_db';
}
